import React, { Component } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Pagination from "react-js-pagination";
import $ from 'jquery';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import { scrollToTopValidate,PageTitle } from "../Helpers/SettingHelper";
/* import { GET_VIEWUSERLIST } from '../../actions'; */
import { apiUrl} from'../Config/Config';
import axios from 'axios';
import moment from 'moment';
import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button
} from "react-bootstrap";
const withRouter = WrappedComponent => props => {
	const params = useParams();
	const  navigate = useNavigate();
	// etc... other react-router-dom v6 hooks
  
	return (
	  <WrappedComponent
		{...props}
		params={params}
		navigate ={navigate}
		// etc...
	  />
	);
  };
class View extends Component {
  
  constructor(props)
  {
    super(props); 
    const bookingid = (typeof props.params.ID === 'undefined') ? '' : props.params.ID;

    this.state = {      
      bookingid: bookingid,
      userlistview:'',
      familtlistview:'',
    };

    axios.get(apiUrl+"companyfrontend/bookinglistdetail?id="+bookingid).then(res => {
			if(res.data.status == 'success'){
				const formdata = res.data.bookinglist;
			if(formdata.status === 'A'){
				this.setState({selectedOption:{value: 'active', label: 'Active'}});
			}else{
				this.setState({selectedOption:{value: 'inactive', label: 'Inactive'}});

			}
			this.setState({userlistview:res.data.bookinglist[0]});
						
			}
			
		}); 
  }

   
   componentDidMount() {
     document.title = PageTitle('User View');
   }

   componentDidUpdate(prevProps,prevState){

   }
   componentWillReceiveProps(Props){
   
    
   }
   
  render() {
    const navigate = this.props.navigate;

    var mobileno = ((this.state.userlistview.mobile === null)||((this.state.userlistview.mobile === ''))) ?  this.state.userlistview.mobile = 'N/A' : this.state.userlistview.mobile;
    var available_from_date = moment(this.state.userlistview.date).format("MMM DD YYYY")+', '+this.state.userlistview.hours+':'+this.state.userlistview.minutes+' '+this.state.userlistview.meridiam+' to '+this.state.userlistview.to_hours+':'+this.state.userlistview.to_minutes+' '+this.state.userlistview.to_meridiam; 
    var lastname = ((this.state.userlistview.lastname === null)||(this.state.userlistview.lastname === "")) ?  this.state.userlistview.lastname = 'N/A' : this.state.userlistview.lastname;

    if(this.state.userlistview.status == 'A'){
      var status = 'Active';
    }else{
        var status = 'Inactive';
    }
    return (
      <div className="wrapper"> 
 
    <Header />
    <MenuSidebar currentpage="buyparking" />  
      
      <div className="content"> 
        <div className="content-wrapper">
         <div class="content-wrapper-before"></div>
            <div className="content-body">
               <div className="form-wrapper leaa-admin-head card">
               <div className="content-wrapper">
                  <a onClick={() => navigate(-1)}>Back</a>    
               </div>
                <div className="title">
                  <h3>Bookings Details</h3>
                </div>
                <div className="form-row">
                    <div className="details_left">
                        <div className="view-details">
                          <div className="view-details-one">
                              <p><b>Slot ID<span>:</span> </b></p>
                          </div>
                          <div className="view-details-two">
                              <p>{this.state.userlistview.booking_id}</p>
                          </div>
                        </div>
                        <div className="view-details">
                          <div className="view-details-one">
                              <p><b>Name<span>:</span> </b></p>
                          </div>
                          <div className="view-details-two">
                              <p>{this.state.userlistview.firstname}</p>
                          </div>
                        </div>
                        <div className="view-details">
                          <div className="view-details-one">
                              <p><b>Email<span>:</span> </b></p>
                          </div>
                          <div className="view-details-two">
                              <p>{this.state.userlistview.email}</p>
                          </div>
                        </div>
                        <div className="view-details">
                          <div className="view-details-one">
                              <p><b>Contact<span>:</span> </b></p>
                          </div>
                          <div className="view-details-two">
                              <p>{mobileno}</p>
                          </div>
                          
                        </div>
                        <div className="view-details">
                          <div className="view-details-one">
                              <p><b>Address<span>:</span> </b></p>
                          </div>
                          <div className="view-details-two">
                          <p>{this.state.userlistview.full_address}</p>
                          </div>
                          
                        </div>
                        <div className="view-details">
                          <div className="view-details-one">
                              <p><b>Status<span>:</span> </b></p>
                          </div>
                          <div className="view-details-two">
                              <p>{this.state.userlistview.status}</p>
                          </div>
                        </div>
                        <div className="view-details">
                          <div className="view-details-one">
                              <p><b>Available On<span>:</span> </b></p>
                          </div>
                          <div className="view-details-two">
                              <p>{available_from_date}</p>
                          </div>
                        </div>
                        {this.state.userlistview.buyer_id && (
                           <>

                              <div className="title">
                                <h3>Buyer Details</h3>
                              </div>
                          <div className="view-details">
                              <div className="view-details-one">
                                  <p><b>Name<span>:</span> </b></p>
                              </div>
                            <div className="view-details-two">
                                <p>{this.state.userlistview.buyer_username}</p>
                            </div>
                          </div>
                          <div className="view-details">
                              <div className="view-details-one">
                                  <p><b>Email<span>:</span> </b></p>
                              </div>
                            <div className="view-details-two">
                                <p>{this.state.userlistview.buyer_email}</p>
                            </div>
                          
                          </div>
                          <div className="view-details">
                              <div className="view-details-one">
                                  <p><b>Parking Charge<span>:</span> </b></p>
                              </div>
                            <div className="view-details-two">
                                <p>${this.state.userlistview.price}</p>
                            </div>
                          
                          </div>
                          <div className="view-details">
                              <div className="view-details-one">
                                  <p><b>Transaction id<span>:</span> </b></p>
                              </div>
                            <div className="view-details-two">
                                <p>${this.state.userlistview.transaction_id}</p>
                            </div>
                          
                          </div>
                          
                           </>
                        )}

                       
                        
                      
                        



                    </div>
                </div>
                 
                  
               
              </div>            
            
          </div>
         </div> 
        </div>        
    </div>
    );
  }
}
export default withRouter(View);
